import { selectLangByViewKey } from "~/pages/SRR/utils/getTableHeaders";
import i18n from "~/language";

export const nameColumnForUniqueVinTable = [
  "1stYear",
  "2ndYear",
  "3rdYear",
  "4thYear",
  "5thYear",
  "totalByFiveYears",
  "6thYear",
  "7thYear",
  "8thYear",
  "9thYear",
  "10thYear",
];

export const nameColumnForSalesTable = [
  "last1",
  "last2",
  "last3",
  "last4",
  "last5",
  "totalByFiveYears",
  "last6",
  "last7",
  "last8",
  "last9",
  "last10",
];

export const nameColumnForPercentTable = [
  "1stYear",
  "2ndYear",
  "3rdYear",
  "4thYear",
  "5thYear",
  "totalByFiveYears",
  "6thYear",
  "7thYear",
  "8thYear",
  "9thYear",
  "10thYear",
];

export const getHeaders = (reportConfigData) => {
  const cellName =
    reportConfigData && reportConfigData.kindReport
      ? selectLangByViewKey[reportConfigData.kindReport.value]
      : "";

  const UniqueVinTableHeader = {
    options: [cellName, "ten_year", i18n.t("srr.UniqueServiceCallsByYear")],
    optionsChildren: [cellName, "ten_year", ...nameColumnForUniqueVinTable],
    arrTableRowsPeriod: [i18n.t("srr.UniqueServiceCallsByYear")],
  };

  const SalesTableHeader = {
    options: [cellName, "SoldCountBy10Years", i18n.t("srr.SoldCountByYears")],
    optionsChildren: [cellName, "ten_year_sales", ...nameColumnForSalesTable],
    arrTableRowsPeriod: [i18n.t("srr.SoldCountByYears")],
  };

  const PercentTableHeader = {
    options: [cellName, "commonLoyalty", i18n.t("srr.loyaltyPercent")],
    optionsChildren: [cellName, "commonLoyalty", ...nameColumnForPercentTable],
    arrTableRowsPeriod: [i18n.t("srr.loyaltyPercent")],
  };

  return { UniqueVinTableHeader, SalesTableHeader, PercentTableHeader };
};

export const rowHelper = (row) => {
  let fiveYears = 0;

  return [
    row.name,
    row.ten_year,
    ...row.data
      .map(({ count }) => count)
      .reduce((acc, current, index) => {
        if (index === 5) {
          return [...acc, row.five_year, current];
        }

        return [...acc, current];
      }, []),
  ];
};
